export default {
    Chairman: 1,
    Commissioner: 2,
}
  